import exportNo from '../resources/no/export.json';
import exportSe from '../resources/se/export.json';
import { ExportLanguageResources } from '../types/ExportResources';

export const exportI18nResources: ExportLanguageResources = {
  no: { export: exportNo },
  se: { export: exportSe },
};
